import { Divider } from "@mui/material";
import { neutral } from "@flat-ui";

/** Simple vertical divider between action buttons */
export function SphereActionDivider(): JSX.Element {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{
        height: "17px",
        alignSelf: "center",
        color: neutral[200],
        marginX: "4px",
        paddingY: "6px",
      }}
    />
  );
}
